import * as React from 'react';

import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';

import { SpacingSpace } from 'uitk-react-spacing/dist/types';
import { UitkCardAlohaContentSectionBorder } from 'uitk-react-cards/dist/aloha/types';

import { UitkCardAloha, UitkCardAlohaContentSection } from 'uitk-react-cards';
import { UitkFigure, UitkFigureAspectRatioType } from 'uitk-react-images';
import { UitkImageSkeleton, UitkTextSkeleton } from 'uitk-react-skeleton';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';

export const LoadingPlaceholder: React.FC = () => {
  const elems = [0, 1, 2];

  return (
    <>
      {elems.map((_, index) => (
        <Viewport>
          <ViewSmall>
            <ListingPlaceholderSmall key={`listing-placeholder-${index}`} />
          </ViewSmall>
          <ViewLarge>
            <OffersListingPlaceholderLarge key={`listing-placeholder-${index}`} />
          </ViewLarge>
        </Viewport>
      ))}
    </>
  );
};
LoadingPlaceholder.displayName = 'LoadingPlaceholder';

export const ListingPlaceholderSmall: React.FC = () => (
  <UitkSpacing className="listing__card" margin={{ block: 'four' }}>
    <UitkCardAloha>
      <CardGalleryPlaceholder
        aspectRatio={UitkFigureAspectRatioType.R21_9}
        className="uitk-card-roundcorner-top-left uitk-card-roundcorner-top-right"
      />
      <CardContentPlaceholder />
    </UitkCardAloha>
  </UitkSpacing>
);
ListingPlaceholderSmall.displayName = 'ListingPlaceholderSmall';

export const OffersListingPlaceholderLarge: React.FC = () => (
  <UitkSpacing className="listing__card" margin={{ block: 'four' }}>
    <UitkCardAloha>
      <UitkLayoutGrid columns={4}>
        <UitkLayoutGridItem colSpan={1}>
          <UitkSpacing padding={{ block: 'three', inlinestart: 'three' }}>
            <div>
              <CardGalleryPlaceholder aspectRatio={UitkFigureAspectRatioType.R16_9} className="uitk-card-roundcorner-all" />
            </div>
          </UitkSpacing>
        </UitkLayoutGridItem>
        <UitkLayoutGridItem colSpan={3}>
          <UitkSpacing padding={{ blockend: 'twelve' }}>
            <div>
              <CardContentPlaceholder />
            </div>
          </UitkSpacing>
        </UitkLayoutGridItem>
      </UitkLayoutGrid>
    </UitkCardAloha>
  </UitkSpacing>
);
OffersListingPlaceholderLarge.displayName = 'OffersListingPlaceholderLarge';

export const SearchListingPlaceholderLarge: React.FC = () => (
  <UitkSpacing className="listing__card" margin={{ block: 'four' }}>
    <UitkCardAloha>
      <UitkLayoutGrid columns={3}>
        <UitkLayoutGridItem colSpan={1}>
          <CardGalleryPlaceholder
            aspectRatio={UitkFigureAspectRatioType.R21_9}
            className="uitk-card-roundcorner-top-left uitk-card-roundcorner-bottom-left"
          />
        </UitkLayoutGridItem>
        <UitkLayoutGridItem colSpan={2}>
          <UitkSpacing padding={{ blockend: 'twelve' }}>
            <div>
              <CardContentPlaceholder />
            </div>
          </UitkSpacing>
        </UitkLayoutGridItem>
      </UitkLayoutGrid>
    </UitkCardAloha>
  </UitkSpacing>
);
SearchListingPlaceholderLarge.displayName = 'SearchListingPlaceholderLarge';

interface CardGalleryPlaceholderProps {
  aspectRatio: UitkFigureAspectRatioType;
  className: string;
}

const CardGalleryPlaceholder: React.FC<CardGalleryPlaceholderProps> = ({ aspectRatio, className }) => (
  <UitkFigure ratio={aspectRatio} className={className}>
    <UitkImageSkeleton />
  </UitkFigure>
);
CardGalleryPlaceholder.displayName = 'CardGalleryPlaceholder';

interface CardContentPlaceholderProps {
  border?: UitkCardAlohaContentSectionBorder;
}

const CardContentPlaceholder: React.FC<CardContentPlaceholderProps> = ({ border }) => (
  <UitkCardAlohaContentSection border={border}>
    <PaddedSkeletonText />
    <PaddedSkeletonText blockend="twelve" type="secondary" />
  </UitkCardAlohaContentSection>
);
CardContentPlaceholder.displayName = 'CardContentPlaceholder';

interface PaddedSkeletonTextProps {
  blockend?: SpacingSpace;
  type?: 'primary' | 'secondary';
}

export const PaddedSkeletonText: React.FC<PaddedSkeletonTextProps> = ({ blockend, type }) => (
  <UitkSpacing margin={{ blockend: blockend || 'two' }}>
    <UitkTextSkeleton animation={true} type={type} />
  </UitkSpacing>
);
PaddedSkeletonText.displayName = 'PaddedSkeletonText';

export const PriceBoxPlaceholder: React.FC = () => (
  <UitkSpacing margin={{ block: 'three' }}>
    <UitkCardAloha>
      <UitkCardAlohaContentSection>
        <PaddedSkeletonText blockend="three" />
        <PaddedSkeletonText type="secondary" />
      </UitkCardAlohaContentSection>
    </UitkCardAloha>
  </UitkSpacing>
);
PriceBoxPlaceholder.displayName = 'PriceBoxPlaceholder';
